import React, { FC } from 'react';

import Item from 'components/Explore/Item';
import { CardTypeOptions, UnionDiscoverFollowingObjectType } from 'constants/graphqlTypes';
import { FOLLOWING_TAB_VIEW, getExploreItemDataTestId } from 'constants/aqa/explore';
import SparkCard from 'components/Sparks/Views/SparkCard';
import useTheme from 'helpers/useTheme';
import { useFeaturedFlagEnabled } from 'helpers/posthogHooks';
import { EFeaturedFlags } from 'types/EFeatureFlags';
import BigCard from 'components/List/BigCard';
import { getCardLayout } from '../helpers';
import ListGroup from '../ListGroup';
import MixedGroup from '../MixedGroup';

import { StyledSparkContainer } from './styled';

const TabItem: FC<{
  currentItem: UnionDiscoverFollowingObjectType;
  items: UnionDiscoverFollowingObjectType[];
  isFirstItem?: boolean;
}> = ({ currentItem, items, isFirstItem = false }) => {
  const isViewSparks = useFeaturedFlagEnabled(EFeaturedFlags.ViewSparks);
  const isDark = useTheme();

  return (
    <>
      {currentItem.__typename === 'CardSchema' &&
        currentItem.type !== CardTypeOptions.Collection &&
        currentItem.type !== CardTypeOptions.Spark && (
          <Item
            dataTestId={getExploreItemDataTestId(getCardLayout(currentItem, items), FOLLOWING_TAB_VIEW)}
            item={{ card: currentItem, layout: getCardLayout(currentItem, items) }}
          />
        )}
      {currentItem.__typename === 'CardSchema' && currentItem.type === CardTypeOptions.Collection && (
        <BigCard item={currentItem} />
      )}
      {currentItem.__typename === 'CardSchema' && currentItem.type === CardTypeOptions.Spark && isViewSparks && (
        <StyledSparkContainer>
          <SparkCard
            isDark={isDark}
            card={currentItem}
            minimal
            isOtherUser
            expandedHeader
            showFooterMenu
            isFirstItem={isFirstItem}
          />
        </StyledSparkContainer>
      )}
      {currentItem.__typename === 'ListGroupFollowSchema' && currentItem?.cardItems?.length && (
        <ListGroup item={currentItem} />
      )}
      {currentItem.__typename === 'MixedGroupFollowSchema' && <MixedGroup item={currentItem} />}
    </>
  );
};

export default TabItem;
